export default __webpack_public_path__ + "static/media/slider2.ec9a396d.jpeg";